// All options / translations/ values that available for the query cycles

// Sort Markers / Sort Direction
// Date Range Filter Options
// Cycle Lists

import {SortDirection} from '@angular/material/sort';
import {CycleListCategoryType, CycleListData, CycleListType, CycleStatusType, ICycleListCategory, ICycleListTypeData} from '@core/api/data-access';
import {DateRangeType, QueryCycleSortMarker} from '@global-data';
import {Cached} from '@utils';
import {FilterOptions} from '@shared-types';

export type IQueryCycleData = {
	Sorting: {
		markers: Record<QueryCycleSortMarker, FilterOptions>;
		directions: Record<SortDirection, FilterOptions<SortDirection>>;
	};
	DateRange: {
		types: Record<DateRangeType, FilterOptions>;
	};
	CycleLists: {
		byCategory: Record<CycleListCategoryType, ICycleListCategory>;
		byListType: Record<CycleListType, ICycleListTypeData>;
		cycleStatusToCycleLists: Record<CycleStatusType, ICycleListTypeData[]>;
	};
};

export class QueryCyclesData {
	@Cached()
	static getQueryCycleData(): IQueryCycleData {
		const cycleListData = CycleListData.getCycleListCategoriesData();
		const cycleListTypes: Record<CycleListType, ICycleListTypeData> = Object.values(cycleListData)
			.flatMap(category => Object.values(category.types))
			.reduce(
				(acc, type) => {
					acc[type.label] = type;
					return acc;
				},
				{} as Record<CycleListType, ICycleListTypeData>,
			);
		const cycleListStatus: Record<CycleStatusType, ICycleListTypeData[]> = Object.values(cycleListData)
			.flatMap(category => Object.values(category.types))
			.reduce(
				(acc, type) => {
					acc[type.label] = acc[type.label] || [];
					acc[type.label].push(type);
					return acc;
				},
				{} as Record<CycleStatusType, ICycleListTypeData[]>,
			);

		return {
			Sorting: {
				markers: {
					[QueryCycleSortMarker.LastUpdate]: {
						label: 'pages.cycles.lastupdate',
						icon: 'fa-duotone fa-calendar-clock',
						isDefaultFilter: true,
						value: QueryCycleSortMarker.LastUpdate,
					},
					[QueryCycleSortMarker.CreateDate]: {
						label: 'pages.cycles.creation_date',
						icon: 'fa-duotone fa-calendar-plus',
						isDefaultFilter: false,
						value: QueryCycleSortMarker.CreateDate,
					},
					[QueryCycleSortMarker.Creator]: {
						label: 'pages.cycles.creator',
						icon: 'fa-duotone fa-user',
						isDefaultFilter: false,
						value: QueryCycleSortMarker.Creator,
					},
				},
				directions: {
					['asc']: {
						label: 'dccomp.dc-table.sort.asc',
						icon: 'fa-solid fa-arrow-up',
						value: 'asc',
					},
					['desc']: {
						label: 'dccomp.dc-table.sort.desc',
						icon: 'fa-solid fa-arrow-down',
						value: 'desc',
					},
					['']: {
						label: 'dccomp.dc-table.sort.none',
						icon: 'fa-solid fa-sort',
						value: '',
					},
				},
			},
			DateRange: {
				types: {
					[DateRangeType.LastUpdate]: {
						label: 'pages.cycles.lastupdate',
						icon: 'fa-duotone fa-calendar-clock',
						isDefaultFilter: true,
						value: DateRangeType.LastUpdate,
					},
					[DateRangeType.CreateDate]: {
						label: 'pages.cycles.creation_date',
						icon: 'fa-duotone fa-calendar-plus',
						isDefaultFilter: false,
						value: DateRangeType.CreateDate,
					},
				},
			},
			CycleLists: {
				byCategory: cycleListData,
				byListType: cycleListTypes,
				cycleStatusToCycleLists: cycleListStatus, // CycleStatusType => CycleListType[]
			},
		};
	}
}
